// External libraries
import type { ReactNode } from 'react';
import React from 'react';

// Internal modules
import { logTermClick } from './utils';
import type { TermsMapKey } from './constants';
import { TERMS_MAP } from './constants';
import { Link } from '@/components/Common';
import {
  buildTermsUrl,
  getContent,
  getLocale,
  getNestedContentKeys,
} from '@/lib';

type LinkKey = 'brTag' | 'lang' | 'country' | 'locale' | TermsMapKey;
export const getTermsLinks = (
  termsKey: string,
  isSubmitting: boolean,
): Partial<Record<LinkKey, ReactNode>> => {
  const termsLinks = getNestedContentKeys(termsKey) as LinkKey[];
  if (!Array.isArray(termsLinks)) {
    return {};
  }

  const { country, language, locale } = getLocale();
  return termsLinks.reduce(
    (termsObj, link) => {
      switch (link) {
        case 'brTag':
          termsObj[link] = <br />;
          return termsObj;
        case 'lang':
          termsObj[link] = language;
          return termsObj;
        case 'country':
          termsObj[link] = country;
          return termsObj;
        case 'locale':
          termsObj[link] = locale;
          return termsObj;
        default:
        // Do nothing
      }

      if (!TERMS_MAP[link]) {
        return termsObj;
      }

      const termLinkProps = {
        isSubmitting,
        linkName: link,
        ...TERMS_MAP[link],
      };

      termsObj[link] = <TermLink {...termLinkProps} />;

      return termsObj;
    },
    {} as Record<LinkKey, ReactNode>,
  );
};

interface TermLinkProps {
  contentKey: string;
  isSubmitting: boolean;
  path?: string;
  useFunction?: string;
  getDynamicPath?: () => string;
  testId?: string;
}

export const TermLink = ({
  contentKey,
  isSubmitting,
  testId,
  ...rest
}: TermLinkProps): JSX.Element => {
  return (
    <Link
      onClick={() => logTermClick(contentKey)}
      testId={testId}
      // @ts-expect-error TODO: Code path does not handle undefined return type
      href={isSubmitting ? null : buildTermsUrl(rest)}
      text={getContent(`compliance.${contentKey}`)}
    />
  );
};
